import * as server from "@/utils/http"

export const _page = params => server.get("/field-config/page", params);

export const _fieldConfigList = params => server.get("/field-config/list", params);

export const _get = params => server.get("/field-config/get", params);

export const _generalField = params => server.get("/field-config/general", params);

export const _copyField = params => server.post("/field-config/copy", params);

export const _save = params => server.post(params.id ? "/field-config/update" : "/field-config/save", params);

export const _updateStatus = params => server.get("/field-config/updateStatus", params);

